import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { SettingsService } from '../../settings/settings.service';

@Injectable({providedIn: 'root'})
export class StocksApiProvider extends HttpService {

    /**
     * Serviço de integração ao backend da stocks api
     */
    constructor(http: HttpClient, settingsService: SettingsService) {
        super('stocksApi', http, settingsService);
    }

}
